module.exports = __webpack_public_path__ + "assets/img/btn-view-info-hover-f13474bb.png";